import { render, staticRenderFns } from "./ExplosiveClassroom.vue?vue&type=template&id=20588364&scoped=true"
import script from "./ExplosiveClassroom.vue?vue&type=script&lang=js"
export * from "./ExplosiveClassroom.vue?vue&type=script&lang=js"
import style0 from "../assets/css/ashore.css?vue&type=style&index=0&id=20588364&prod&scoped=true&lang=css&external"
import style1 from "./ExplosiveClassroom.vue?vue&type=style&index=1&id=20588364&prod&lang=scss&scoped=true"
import style2 from "./ExplosiveClassroom.vue?vue&type=style&index=2&id=20588364&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20588364",
  null
  
)

export default component.exports